import React from 'react';

import PageTemplate from '../../components/template/PageTemplate';
import CategoryCreateManagementContainer from '../../containers/category/list/CategoryCreateManagementContainer';
import { CATEGORY_PAGE_NAME } from '../../constants/service/app/categoryConstants';

const CategoryCreateManagement = () => {
  return (
    <PageTemplate pageName={CATEGORY_PAGE_NAME.CATEGORY_CREATE_MANAGEMENT}>
      <CategoryCreateManagementContainer />
    </PageTemplate>
  );
};

export default CategoryCreateManagement;
